var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M15 5 5 15M5 5l10 10"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.9a3ce408a99ea2d91472eaefa067b529.svg";